import styled from "styled-components";

export const HomeContainer = styled.div`
  min-height: 100vh;
  padding-inline: 15px;
`;

export const HomeCarousel = styled.div`
  height: 200px;
  background-color: black;
  margin-block: 30px;
`;

export const HomeECECard = styled.div`
    /* height: calc(200px - 30px); */
    padding: 20px 0;
    background-color: ${({ theme }) => theme.colors.primary};
    border: 1px solid #7B36EE;
`;

export const ReferralContestContainer = styled.div`
  margin-block: 30px;
`;

export const CountUpCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-block: 30px;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.primary};
`;
export const HomeRPCard = styled.div`
  padding: 20px;
  margin-block: 30px;
  background-color: ${({ theme }) => theme.colors.primary};
  /* height: 200px; */
`;
